<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-card class="elevation-12">
                    <v-card-title>
                        HPC Subscription
                    </v-card-title>
                    <v-data-table :loading="subscriptionLoading" :sort-by="['status', 'start_date']" :sort-desc="[false, true]" must-sort :items-per-page="10" :headers="headers" :items="subscriptions" item-key="id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr :class="{'font-weight-bold success--text': props.item.status == 'active'}">
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.cycle }}</td>
                                <td>{{ props.item.price | currency }}</td>
                                <td class="text-left">{{ props.item.start_date | moment("DD/MM/YYYY")}}</td>
                                <td class="text-left">{{ props.item.end_date | moment("DD/MM/YYYY")}}</td>
                                <td>{{ props.item.activity }}</td>
                                <td class="text-left">{{ props.item.status | capitalize }}</td>
                                <td class="text-left mob_small_btn">
                                    <v-select
                                        v-if="props.item.status === 'active'"
                                        :items="actionItems"
                                        item-text="label"
                                        item-value="action"
                                        label="Select Action"
                                        solo
                                        dense
                                        hide-details
                                        clearable
                                        placeholder="Select Action"
                                        :value="actionSelections[props.item.id]"
                                        @change="handleAction($event, props.item)"
                                        @click:clear="actionSelections[props.item.id] = null"
                                    ></v-select>
                                    <!-- <v-btn v-if="props.item.status == 'active'" class="pa-0" color="warning" @click="openDialog(props.item)"><v-icon small>edit</v-icon></v-btn> - <v-btn v-if="props.item.status == 'active' || props.item.status == 'suspended'" class="pa-0" color="error" @click="openCardDialog(props.item)"><v-icon small>credit_card</v-icon></v-btn> -->
                                </td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No subscriptions Yet
                            </div>
                        </template>
                    </v-data-table>
                </v-card>

                <!-- Dialog -->
                <v-dialog v-model="dialog" max-width="290">
                    <v-card>
                        <v-card-title class="text-h5">Manage Subscription</v-card-title>
                        <v-card-text>
                            <p>Do you want to cancel or pause the subscription for <strong>{{ selectedItem?.name }}</strong>?</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :disabled="btnLoad" :loading="btnLoad && btnAction == 'pause'" color="warning" @click="sendAction('pause')">Pause</v-btn>
                            <v-btn :disabled="btnLoad" :loading="btnLoad && btnAction == 'cancel'" color="error" @click="sendAction('cancel')">Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text @click="dialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- DialogCancel -->
                <v-dialog v-model="dialogcancel" max-width="290">
                    <v-card>
                        <v-card-title class="text-h5">Cancel Subscription</v-card-title>
                        <v-card-text>
                            <p>Do you want to cancel the subscription for <strong>{{ selectedItem?.name }}</strong>?</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :disabled="btnLoad" :loading="btnLoad && btnAction == 'cancel'" color="error" @click="sendAction('cancel')">Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text @click="dialogcancel = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- DialogPause -->
                <v-dialog v-model="dialogpause" max-width="360">
                    <v-card>
                        <v-card-title class="text-h5">Pause Subscription</v-card-title>
                        <v-card-text>
                            <p>Pause the subscription for <strong>{{ selectedItem?.name }}</strong>.</p>
                            <p>Pause Dates are both <strong>inclusive</strong>.</p>
                            <v-menu v-model="pauseStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formatDate(pauseStartDate)" label="Pause Start Date" prepend-icon="event" readonly v-bind="attrs" v-on="on" clearable @click:clear="pauseStartDate = null"></v-text-field>
                                </template>
                                <v-date-picker v-model="pauseStartDate" :min="today" @input="pauseStartMenu = false"></v-date-picker>
                            </v-menu>
                            <v-menu v-model="pauseEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formatDate(pauseEndDate)" label="Pause End Date" prepend-icon="event" readonly v-bind="attrs" v-on="on" clearable @click:clear="pauseEndDate = null"></v-text-field>
                                </template>
                                <v-date-picker v-model="pauseEndDate" :min="pauseStartDate" :max="pauseMaxEndDate" @input="pauseEndMenu = false"></v-date-picker>
                            </v-menu>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :disabled="btnLoad || !pauseStartDate || !pauseEndDate" :loading="btnLoad && btnAction == 'pause'" color="warning" @click="sendAction('pause')">Pause</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text @click="dialogpause = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Dialog Card -->
                <v-dialog v-model="dialogcard" max-width="490">
                    <v-card>
                        <v-card-title class="text-h5">Update Credit Card</v-card-title>
                        <v-card-text>
                            <small v-if="paymentErrors.any()" class="d-block mb-2 caption font-weight-bold secondary--text" v-html="getPaymentMessage"></small>
                            <component :is="ftGateway" @submitted-pay="submitPay"></component>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :loading="payLoading" :disabled="!validPaymentForm" color="primary" @click="SubmitCard" class="mr-2 text-left">Submit</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="clearPay" color="warning" :disabled="payLoading" class="text-left">Clear</v-btn>
                            <v-btn text @click="dialogcard = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Snackbar -->
                <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
                    {{ snackbar.text }}
                </v-snackbar>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';
import moment from 'moment';

import { EventBus } from "@shared/EventBus.js";
import Eway from "@components/gateways/Eway.vue";

export default {
    name: 'HpcSubscriptionModule',
    components: {
         eway: Eway,
    },
    data () {
        return {
            ftGateway: gtwPw,
            search: '',
            dialog: false,
            dialogcancel: false,
            dialogpause: false,
            dialogcard: false,
            actionSelections: {},
            pauseStartDate: null,
            pauseEndDate: null,
            pauseStartMenu: false,
            pauseEndMenu: false,
            validPaymentForm: true,
            selectedItem: null,
            btnLoad: false,
            btnAction: '',
            snackbar: {
                show: false,
                text: '',
                color: ''
            },
            actionItems: [
                { label: 'Cancel Subscription', action: 'cancel' },
                { label: 'Pause Subscription',  action: 'pause' },
                { label: 'Update Credit Card',  action: 'card' },
            ],
            headers: [
                { text: 'Plan', value: 'name'},
                { text: 'Cycle', value: 'cycle'},
                { text: 'Price', value: 'price'},
                { text: 'Start Date', value: 'start_date' },
                { text: 'End Date', value: 'end_date' },
                { text: 'Activity', value: 'activity' },
                { text: 'Status', value: 'status' },
                { text: 'Action', value: '' },
            ],
        }
    },
    computed: {
        today() {
            return new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Sydney' });
        },
        pauseMaxEndDate() {
            return this.pauseStartDate ? moment(this.pauseStartDate).add(8, 'weeks').format('YYYY-MM-DD') : null;
        },
        subscriptionLoading(){
            return this.$store.getters['hpcsubscription/subscriptionStatus'] == 'loading';
        },
        subscriptions(){
            return this.$store.getters['hpcsubscription/subscriptions'];
        },
        paymentErrors() {
            return this.$store.getters["hpcsubscription/paymentErrors"];
        },
        getPaymentMessage() {
            if (this.paymentErrors.any()) {
                if (this.paymentErrors.has("error_auth")) {
                    return this.paymentErrors.get("error_auth");
                }

                if (this.paymentErrors.has("error_paid")) {
                    return this.paymentErrors.get("error_paid");
                }

                if (this.paymentErrors.has("error_response")) {
                    return this.paymentErrors.get("error_response");
                }

                if (this.paymentErrors.has("error_validation")) {
                    return "Subscription Data Invalid";
                }

                if (this.paymentErrors.has("error_payment")) {
                    return this.paymentErrors.get("error_payment");
                }

                return "Subscription Invalid";
            }

            return "";
        },
        payLoading() {
            return this.$store.getters["hpcsubscription/paymentStatus"] == "loading";
        },
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : null;
        },
        handleAction(action, item) {
            if (!action) return;
            this.$set(this.actionSelections, item.id, action);
            const map = {
                cancel: () => this.openCancelDialog(item),
                pause:  () => this.openPauseDialog(item),
                card:   () => this.openCardDialog(item),
            };
            if (map[action]) map[action]();
        },
        openDialog(item) {
            this.selectedItem = item;
            this.dialog = true;
        },
        openCancelDialog(item) {
            this.selectedItem = item;
            this.dialogcancel = true;
        },
        openPauseDialog(item) {
            this.selectedItem = item;
            this.pauseStartDate = null;
            this.pauseEndDate = null;
            this.dialogpause = true;
        },
        openCardDialog(item) {
            this.selectedItem = item;
            this.dialogcard = true;
            EventBus.$emit("clear-pay");
            this.$store.dispatch("hpcsubscription/clearPaymentErrors");
        },
        clearPay() {
            this.alert = false;
            EventBus.$emit("clear-pay");
            this.$store.dispatch("hpcsubscription/clearPaymentErrors");
        },
        SubmitCard: function() {
            EventBus.$emit("submit-pay");
        },
        submitPay: function(payload) {
            this.validPaymentForm = false;

            const cardPayload = payload;

            this.$store
                .dispatch("hpcsubscription/updateCard", {
                    cardPayload: cardPayload,
                    subId: this.selectedItem.id
                })
                .then(data => {
                    // console.log(data);
                    this.snackbar.text = 'Card details updated successfully.';
                    this.snackbar.color = 'success';
                    this.snackbar.show = true;
                    this.dialogcard = false;

                    setTimeout(() => {
                        this.$router.push({ name: "hpcDashboard" });
                    }, 1000);
                })
                .catch(err => {
                    this.validPaymentForm = true;
                    // console.log(err);

                    setTimeout(() => {
                        EventBus.$emit("clear-pay");
                    }, 500);
                });
        },
        sendAction(action) {
            this.btnLoad = true;
            this.btnAction = action;

            const payload = { id: this.selectedItem.id, action: action };

            if (action === 'pause') {
                payload.pause_start_date = this.pauseStartDate;
                payload.pause_end_date = this.pauseEndDate;
            }

            this.$store.dispatch("hpcsubscription/sendSubAction", payload).then(() => {
                this.snackbar.text = `Subscription ${action} request sent.`;
                this.snackbar.color = 'success';
                this.snackbar.show = true;
                if (action === 'cancel') {this.dialogcancel = false;}
                if (action === 'pause') {this.dialogpause = false;}
                this.btnLoad = false;
                this.btnAction = '';
                this.actionSelections[this.selectedItem.id] = null;
            }).catch(() => {
                this.snackbar.text = 'Failed to send request.';
                this.snackbar.color = 'error';
                this.snackbar.show = true;
                if (action === 'cancel') {this.dialogcancel = false;}
                if (action === 'pause') {this.dialogpause = false;}
                this.btnLoad = false;
                this.btnAction = '';
                this.actionSelections[this.selectedItem.id] = null;
            });
        }
    },
    beforeCreate(){
        this.$store.dispatch('hpcsubscription/hpcsubscriptionRequest');
    }
};
</script>

<style scoped>
    .v-data-table td {
        height: 58px !important;
    }

    .mob_small_btn .v-btn {
        min-width: 24px !important;
        padding: 0 8px !important;
        height: 24px;
        margin: 0;
    }

    .mob_small_btn .v-btn i {
        margin: 0 !important;
    }
</style>
